import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env.local file.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface User {
  id: string;
  email: string;
  created_at?: string;
}

export interface Favorite {
  id?: string;
  user_id: string;
  name: string;
  link: string;
  club?: string;
  elo?: number;
  classification?: string;
  license_number?: string;
  created_at?: string;
}

export interface UserPreferences {
  id?: string;
  user_id: string;
  my_player_link: string;
  my_player_name?: string;
  my_player_license_number?: string;
  my_player_club?: string;
  my_player_elo?: number;
  my_player_classification?: string;
  profile_avatar?: string;
  created_at?: string;
  updated_at?: string;
}
